import { ChevronDown } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Reveal } from './Reveal';
import { FAQ_ITEMS } from './content';

/**
 * FAQ — styled native <details>/<summary>, no accordion dependency.
 * Keyboard accessible for free; the chevron rotates via group-open.
 */
export function Faq() {
  return (
    <section id="faq" className="border-b border-hairline py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center sm:mb-14">
          <Badge variant="outline" className="mb-4">
            FAQ
          </Badge>
          <h2 className="text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
            Questions, answered
          </h2>
        </div>

        <div className="mx-auto max-w-3xl space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <Reveal key={item.q} delay={Math.min(i * 0.05, 0.2)}>
              <details className="group glass-card rounded-xl px-5">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 rounded-lg py-4 text-left text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
                  {item.q}
                  <ChevronDown className="size-4 shrink-0 text-muted-foreground transition-transform duration-200 ease-out-quart group-open:rotate-180" />
                </summary>
                <p className="border-t border-hairline pb-5 pt-4 text-sm leading-relaxed text-muted-foreground">
                  {item.a}
                </p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
